import i18n from 'i18n';
import { useMemo } from 'react';

import { ALLOWED_LOCALES } from 'config/constants/i18n';
import { Language } from 'modules/user-page/views/user-account/hooks/useUserSettingsContext';

const getLocaleName = (locale: string) => new Intl.DisplayNames(locale, { type: 'language' }).of(locale);

export const useLanguages = () => {
  const { changeLanguage: changeI18nLanguage, language: locale = 'en' } = i18n;

  const languageNames = useMemo<Language[]>(() => {
    return (
      (ALLOWED_LOCALES || []).reduce<Language[]>((langs, locale) => {
        const lang = getLocaleName(locale);

        return lang ? [...langs, { locale, label: lang }] : langs;
      }, []) || []
    );
  }, []);

  const language: Language = useMemo(() => ({ label: getLocaleName(locale)!, locale }), [locale]);

  const changeLanguage = (lang: Language) => {
    changeI18nLanguage(lang.locale);
  };

  return { languageNames, language, changeLanguage };
};
